<template>
  <div v-if="!hidden" class="infobar-menu"  @wheel.stop @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')">
    <div class="title-bar" @mousedown="startDrag">
      <span>信息栏</span> <!-- 这里可以修改标题内容 -->
      <div class="close-button" @click="closeMenu">×</div>
    </div>
    <!-- 非农化处置设定对话框 -->
    <FnczSetDialog :visible="isFnczDialogVisible" :patch="dataInfo ? dataInfo.patch : null" :config="fnczConfig"
      @close="isFnczDialogVisible = false" @confirm="onFnczConfirm" />
    <!-- 是否拒测设定对话框 -->
    <SfjcSetDialog :visible="isSfjcDialogVisible" :value="dataInfo && dataInfo.patch ? dataInfo.patch.SFJC : '否'"
      @close="isSfjcDialogVisible = false" @confirm="onSfjcConfirm" />
    <!-- 紧急图斑/紧急类别设定对话框 -->
    <JjlbSetDialog :visible="isJjlbDialogVisible" :value="dataInfo && dataInfo.patch ? Number(dataInfo.patch.JJLB) || 0 : 0"
      :config="jjlbConfig" @close="isJjlbDialogVisible = false" @confirm="onJjlbConfirm" />

    <!-- 图斑 -->
    <div v-if="dataInfo && dataInfo.patch && dataInfo.level === 3" class="menu-content">
      <!-- 基本信息 -->
      <div v-if="ybFields.length > 0">
        <h3 class="info-title" @click="toggleSection('basicInfo')">
          基本信息
          <span>{{ sectionVisibility.basicInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.basicInfo">
          <template v-for="prop in dataInfo.tableConfig.columns" :key="prop" >
            <p v-if="prop.cate=='yb'">
              <span class="info-strong">{{ prop.label }}:&nbsp;&nbsp;</span>{{ prop.isNum ? Number(dataInfo.patch[prop.name]||0).toFixed(2):dataInfo.patch[prop.name] }}
              &nbsp;&nbsp;<span v-if="prop.photo && dataInfo.patch[prop.name] != '' &&  dataInfo.patch[prop.name] != null"><a class="info-clickable" @click="$emit('getPatchPhotoData',{TCMC:dataInfo.patch.TCMC,TCJC:dataInfo.patch.TCJC,WYBH:dataInfo.patch[prop.name]})">&nbsp;&nbsp;&nbsp;&nbsp;查看照片</a></span>
            </p>
          </template>
          <!-- <p>唯一编号: {{ dataInfo.patch.WYBH }} <span><a class="info-clickable" @click="$emit('getPatchPhotoData',{TCMC:dataInfo.patch.TCMC,TCJC:dataInfo.patch.TCJC,WYBH:dataInfo.patch.WYBH})">&nbsp;&nbsp;&nbsp;&nbsp;查看照片</a></span></p>
          <p>所在镇街: {{ dataInfo.patch.ZJ }}</p>
          <p>所在村庄: {{ dataInfo.patch.CZ }}</p>
          <p>耕地类型: {{ dataInfo.patch.LX }}</p>
          <p>空间位置: {{ dataInfo.patch.KJWZ }} </p> 
          <p>面积: {{ dataInfo.patch.Area.toFixed(2) }} 亩</p> -->
        </div>
        <!-- 可以根据实际情况添加更多基本信息 -->
      </div>
      <!-- 巡查信息 -->
      <div v-if="zzFields.length > 0">
        <h3 class="info-title" @click="toggleSection('inspectionInfo')">
          种植情况
          <span>{{ sectionVisibility.inspectionInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.inspectionInfo">
          <template v-for="prop in dataInfo.tableConfig.columns" :key="prop" >
            <p v-if="prop.cate=='zz'">
              <span class="info-strong">{{ prop.label }}:&nbsp;&nbsp;</span>{{ prop.isNum ? Number(dataInfo.patch[prop.name]||0).toFixed(2):dataInfo.patch[prop.name] }}              
            </p>
          </template>

          <!-- <p><span class="info-strong">是否种植：</span>{{ dataInfo.patch.SFZZ}}</p>
          <p><span class="info-strong">是否具备种植条件：</span>{{ dataInfo.patch.ZZTJ}}</p>
          <p><span class="info-strong">种植情况：</span>{{ dataInfo.patch.ZZQK}}</p>
          <p><span class="info-strong">第一茬种植类别：</span>{{ dataInfo.patch.ZZLB1}}</p>
          <p><span class="info-strong">第一茬种植作物：</span>{{ dataInfo.patch.ZZZW1}}</p>
          <p><span class="info-strong">第二茬种植类别：</span>{{ dataInfo.patch.ZZLB2}}</p>
          <p><span class="info-strong">第二茬种植作物：</span>{{ dataInfo.patch.ZZZW2}}</p>
          <p><span class="info-strong">第三茬种植类别：</span>{{ dataInfo.patch.ZZLB3}}</p>
          <p><span class="info-strong">第三茬种植作物：</span>{{ dataInfo.patch.ZZZW3}}</p>
          可以根据实际情况添加更多种植信息 -->
        </div>
      </div>
      <!-- 巡查信息 -->
      <div v-if="wtFields.length > 0 || dataInfo.patch.YJFL == '非农化' || dataInfo.patch.zgInfo || dataInfo.patch.SFJC">
        <h3 class="info-title" @click="toggleSection('rectificationInfo')">
          问题信息
          <span>{{ sectionVisibility.rectificationInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.rectificationInfo">
          <template v-for="prop in dataInfo.tableConfig.columns" :key="prop" >
            <p v-if="prop.cate=='wt' && !isFnczField(prop.name) && prop.name != 'SFJC' && prop.name != 'JJLB' && prop.name != 'Flag'">
              <span class="info-strong">{{ prop.label }}:&nbsp;&nbsp;</span>{{ prop.isNum ? Number(dataInfo.patch[prop.name]||0).toFixed(2): (prop.todo == 'SHZT'?shztToString(dataInfo.patch[prop.name]): dataInfo.patch[prop.name]) }}
              &nbsp;&nbsp;<span v-if="prop.photo && dataInfo.patch[prop.name] != '' &&  dataInfo.patch[prop.name] != null"><a class="info-clickable" @click="$emit('getProblemPhotoData',{TCMC:dataInfo.patch.TCMC,TCJC:dataInfo.patch.TCJC,WTBH:dataInfo.patch[prop.name]})">&nbsp;&nbsp;&nbsp;&nbsp;问题照片</a></span>
              &nbsp;&nbsp;<span v-if="prop.todo && prop.todo == 'SHZT' && dataInfo.shlc">
                <a v-for="(node,index) in dataInfo.shlc.nodes" :key="index" class="info-clickable" @click="$emit('executeSHByCode',{code:node.code,TCMC:dataInfo.shlc.TCMC,WYBH:dataInfo.shlc.WYBH})">&nbsp;&nbsp;{{node.label}}</a>
              </span>
            </p>
          </template>
          
          <!-- 是否拒测：测绘院在此设定 -->
          <p>
            <span class="info-strong">是否拒测:&nbsp;&nbsp;</span>{{ dataInfo.patch.SFJC || '否' }}
            <span v-if="roleType == 'CHY'">&nbsp;&nbsp;<a class="info-clickable" @click="openSfjcDialog">设定</a></span>
          </p>

          <!-- 紧急图斑/紧急类别：弹窗勾选后一次设定 Flag 与 JJLB -->
          <p>
            <span class="info-strong">紧急类别:&nbsp;&nbsp;</span>{{ isUrgentPatch ? (jjlbText || '未分类') : '非紧急图斑' }}
            <span v-if="canSetJjlb">&nbsp;&nbsp;<a class="info-clickable" @click="openJjlbDialog">设定</a></span>
          </p>

          <!-- 非农化处置信息：仅当一级分类为非农化时显示 -->
          <template v-if="dataInfo.patch.YJFL == '非农化'">
            <p v-for="prop in fnczFields" :key="prop.name">
              <span class="info-strong">{{ prop.label }}:&nbsp;&nbsp;</span>{{ dataInfo.patch[prop.name] || '' }}
            </p>
            <p v-if="roleType == 'ZFD'">
              <span class="info-strong">非农化处置:&nbsp;&nbsp;</span>
              <a class="info-clickable" @click="openFnczDialog">设定</a>
            </p>
          </template>

          <!-- <p><span class="info-strong">存在问题：</span>{{ dataInfo.patch.CZWT}}</p>
          <p><span class="info-strong">问题编号：</span><a class="info-clickable" @click="$emit('getProblemPhotoData',{TCMC:dataInfo.patch.TCMC,TCJC:dataInfo.patch.TCJC,WTBH:dataInfo.patch.WTBH,WTMS:dataInfo.patch.CZWT})">{{ dataInfo.patch.WTBH}}</a></p>
          <p><span class="info-strong">镇街意见：</span>{{ dataInfo.patch.ZJYJ}}</p>
          <p><span class="info-strong">处置措施：</span>{{ dataInfo.patch.CZCS}}</p>
          <p><span class="info-strong">备注：</span>{{ dataInfo.patch.BZ}}</p> -->
          <!-- 可以根据实际情况添加更多整改信息 -->
        </div>
      </div>
    </div>
    <div v-else-if="dataInfo && dataInfo.patch && dataInfo.level === 2" class="menu-content">
        <!-- 镇街信息 -->
      <div>
        <h3 class="info-title" @click="toggleSection('basicInfo')">
          基本信息
          <span>{{ sectionVisibility.basicInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.basicInfo">
          <p><span class="info-strong">镇街名称:</span> {{ dataInfo.patch.ZJ }} </p>
          <p><span class="info-strong">镇街概况:</span> 共有<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}'`})">{{ dataInfo.patch.jbsx.count }}</a>个图斑，共计{{ dataInfo.patch.jbsx.area.toFixed(2) }}亩</p>
          
          <p v-for="(item,index) in dataInfo.patch.jbsx.nodes" :key="index">
            <template v-if="item.count > 0">
              <span class="info-strong">{{item.label}}&nbsp;&nbsp;({{ item.count }}个，{{ item.area.toFixed(2) }}亩)</span>     <!-- 第一层循环，如是否种植 -->
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item,chartIndex:0,label:item.label})"></i></span>
              <template v-for="(yjItem,yjIndex) in item.nodes" :key="yjIndex"><!-- 第一层循环的值，如是否种植 -->
                <template v-if="yjItem.count>0">
                  <br>&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(0,index,yjIndex))" class="info-clickable">{{ yjItem.nodes? (isNodeSectionOpen(indexToSection(0,index,yjIndex))?'▼' : '▶') : '' }}</span>{{ yjItem.label }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}'`})">{{yjItem.count }}</a>个图斑，
                  {{ yjItem.area.toFixed(2) }}亩 
                  &nbsp;&nbsp;<span v-if="yjItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:yjItem,chartIndex:0,label:yjItem.label})"></i></span>
                  
                  <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(0,index,yjIndex))">
                    <template v-for="(ejItem,ejIndex) in yjItem.nodes" :key="ejIndex"><!-- 第二层循环的值，如是否种植下的种植条件 -->
                      <template v-if="ejItem.count > 0">
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(0,index,yjIndex,ejIndex))" class="info-clickable">{{ ejItem.nodes? (isNodeSectionOpen(indexToSection(0,index,yjIndex,ejIndex))?'▼' : '▶') : '●' }}</span> {{ejItem.label}}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}' && item.${yjItem.field}=='${ejItem.value}'`})">{{ejItem.count }}</a>个图斑，
                        {{ ejItem.area.toFixed(2) }}亩 
                        &nbsp;&nbsp;<span v-if="ejItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:ejItem,chartIndex:0,label:ejItem.label})"></i></span>

                        <div class="subItem-p" v-show="isZZLBSectionOpen(ejItem.name)">
                          <template v-for="(sjItem,sjIndex) in ejItem.nodes" :key="sjIndex"><!-- 第三层循环的值，如是否种植下的耕种条件下的种植类别 -->
                            <template v-if="sjItem.count > 0">
                              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ sjItem.name }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}' && item.${yjItem.field}=='${ejItem.value}' && item.${ejItem.field}=='${sjItem.value}'`})">{{sjItem.count }}</a>个图斑，
                              {{ sjItem.area.toFixed(2) }}亩 
                            </template>                        
                          </template>
                        </div>
                      </template>                    
                    </template>
                  </div>                  
                </template>                
              </template>
            </template>
          </p>
          
          <!-- <p><span class="info-strong">耕地类型:</span>  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.jbsx.LX.value,chartIndex:0,label:dataInfo.patch.jbsx.LX.name})"></i></span>
            <template v-for="item in dataInfo.patch.jbsx.LX.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6)}}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.LX=='${item.name}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，{{ item.area.toFixed(2).padEnd(8) }}亩 
            </template>
          </p>
          <p><span class="info-strong">空间位置:</span>  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.jbsx.KJWZ.value,chartIndex:0,label:dataInfo.patch.jbsx.KJWZ.name})"></i></span>
            <template v-for="item in dataInfo.patch.jbsx.KJWZ.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.KJWZ=='${item.name}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，{{ item.area.toFixed(2).padEnd(8) }}亩 
            </template>
          </p>           -->
        </div>
        <!-- 可以根据实际情况添加更多基本信息 -->
      </div>
      <!-- 种植信息 -->
      <div>
        <h3 class="info-title" @click="toggleSection('inspectionInfo')">
          种植信息
          <span>{{ sectionVisibility.inspectionInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.inspectionInfo">
          <p v-for="(item,index) in dataInfo.patch.zzsx.nodes" :key="index">
            <template v-if="item.count > 0">
              <span class="info-strong">{{item.label}}&nbsp;&nbsp;({{ item.count }}个，{{ item.area.toFixed(2) }}亩)</span>     <!-- 第一层循环，如是否种植 -->
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item,chartIndex:1,label:item.label})"></i></span>
              <template v-for="(yjItem,yjIndex) in item.nodes" :key="yjIndex"><!-- 第一层循环的值，如是否种植 -->
                <template v-if="yjItem.count>0">
                  <br>&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(1,index,yjIndex))" class="info-clickable">{{ yjItem.nodes? (isNodeSectionOpen(indexToSection(1,index,yjIndex))?'▼' : '▶') : '' }}</span>{{ yjItem.label }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}'`})">{{yjItem.count }}</a>个图斑，
                  {{ yjItem.area.toFixed(2) }}亩 
                  &nbsp;&nbsp;<span v-if="yjItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:yjItem,chartIndex:1,label:yjItem.label})"></i></span>
                  
                  <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(1,index,yjIndex))">
                    <template v-for="(ejItem,ejIndex) in yjItem.nodes" :key="ejIndex"><!-- 第二层循环的值，如是否种植下的种植条件 -->
                      <template v-if="ejItem.count > 0">
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(1,index,yjIndex,ejIndex))" class="info-clickable">{{ ejItem.nodes? (isNodeSectionOpen(ejItem.name)?'▼' : '▶') : '●' }}</span> {{ejItem.label}}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}' && item.${yjItem.field}=='${ejItem.value}'`})">{{ejItem.count }}</a>个图斑，
                        {{ ejItem.area.toFixed(2) }}亩 
                        &nbsp;&nbsp;<span v-if="ejItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:ejItem,chartIndex:1,label:ejItem.label})"></i></span>

                        <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(1,index,yjIndex,ejIndex))">
                          <template v-for="(sjItem,sjIndex) in ejItem.nodes" :key="sjIndex"><!-- 第三层循环的值，如是否种植下的耕种条件下的种植类别 -->
                            <template v-if="sjItem.count > 0">
                              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ sjItem.name }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}' && item.${yjItem.field}=='${ejItem.value}' && item.${ejItem.field}=='${sjItem.value}'`})">{{sjItem.count }}</a>个图斑，
                              {{ sjItem.area.toFixed(2) }}亩 
                            </template>                        
                          </template>
                        </div>
                      </template>                    
                    </template>
                  </div>                  
                </template>                
              </template>
            </template>
          </p>

          <!-- <p><span class="info-strong">是否种植:</span>  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.SFZZ.value,chartIndex:1,label:dataInfo.patch.zzsx.SFZZ.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.SFZZ.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.SFZZ=='${item.value}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，{{ item.area.toFixed(2).padEnd(8) }}亩 
            </template>
          </p>   
          <p><span class="info-strong">种植条件:</span>  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.ZZTJ.value,chartIndex:1,label:dataInfo.patch.zzsx.ZZTJ.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.ZZTJ.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.ZZTJ=='${item.value}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，{{ item.area.toFixed(2).padEnd(8) }}亩 
            </template>
          </p>  
          <p><span class="info-strong">种植情况:</span>  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.ZZQK.value,chartIndex:1,label:dataInfo.patch.zzsx.ZZQK.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.ZZQK.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.ZZQK=='${item.value}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，{{ item.area.toFixed(2).padEnd(8) }}亩 
            </template>
          </p>   
          <p><span class="info-strong">种植类别:</span>  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.ZZLB.value,chartIndex:1,label:dataInfo.patch.zzsx.ZZLB.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.ZZLB.value" :key="item.name">
              <template v-if="item.count > 0">
                <br> &nbsp;&nbsp; <span @click="toggleZZLBSection(item.name)" class="info-clickable">{{ isZZLBSectionOpen(item.name) ? '▼' : '▶' }}</span>{{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.ZZLB1=='${item.name}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，
                {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item.value,chartIndex:1,label:item.name})"></i></span>
                <div class="subItem-p" v-show="isZZLBSectionOpen(item.name)">                  
                  <template v-for="subItem in item.value" :key="subItem.name">
                    <template  v-if="subItem.count>0">●{{ subItem.name }}:<a class="info-clickable"  @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.ZZZW1=='${subItem.name}'`})">{{ subItem.count }}</a>个图斑，{{ subItem.area.toFixed(2) }}亩<br></template>
                  </template>
                </div>
              </template>              
            </template>
          </p>                    -->
          <!-- 可以根据实际情况添加更多种植信息 -->
        </div>
      </div>
      <!-- 种植信息 -->
      <div>
        <h3 class="info-title" @click="toggleSection('rectificationInfo')">
          问题信息
          <span>{{ sectionVisibility.rectificationInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.rectificationInfo">   
          
          <p v-for="(item,index) in dataInfo.patch.wtsx.nodes" :key="index">
            <template v-if="item.count > 0">
              <span class="info-strong">{{item.label}}&nbsp;&nbsp;({{ item.count }}个，{{ item.area.toFixed(2) }}亩)</span>     <!-- 第一层循环，如是否种植 -->
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item,chartIndex:2,label:item.label})"></i></span>
                &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field],values:[dataInfo.patch.ZJ,'notnull'],label:`${item.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field],values:[dataInfo.patch.ZJ,'notnull'],label:`${item.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>

              <template v-for="(yjItem,yjIndex) in item.nodes" :key="yjIndex"><!-- 第一层循环的值，如是否种植 -->
                <template v-if="yjItem.count>0">
                  <br>&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(2,index,yjIndex))" class="info-clickable">{{ yjItem.nodes? (isNodeSectionOpen(indexToSection(2,index,yjIndex))?'▼' : '▶') : '' }}</span>{{ yjItem.label }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}'`})">{{yjItem.count }}</a>个图斑，
                  {{ yjItem.area.toFixed(2) }}亩 
                  &nbsp;&nbsp;<span v-if="yjItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:yjItem,chartIndex:2,label:yjItem.label})"></i></span>
                  &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field],values:[dataInfo.patch.ZJ,yjItem.value],label:`${yjItem.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                  &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field],values:[dataInfo.patch.ZJ,yjItem.value],label:`${yjItem.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>

                  <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(2,index,yjIndex))">
                    <template v-for="(ejItem,ejIndex) in yjItem.nodes" :key="ejIndex"><!-- 第二层循环的值，如是否种植下的种植条件 -->
                      <template v-if="ejItem.count > 0">
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(2,index,yjIndex,ejIndex))" class="info-clickable">{{ ejItem.nodes? (isNodeSectionOpen(indexToSection(2,index,yjIndex,ejIndex))?'▼' : '▶') : '●' }}</span> {{ejItem.label}}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}' && item.${yjItem.field}=='${ejItem.value}'`})">{{ejItem.count }}</a>个图斑，
                        {{ ejItem.area.toFixed(2) }}亩 
                        &nbsp;&nbsp;<span v-if="ejItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:ejItem,chartIndex:2,label:ejItem.label})"></i></span>
                        &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field,yjItem.field],values:[dataInfo.patch.ZJ,yjItem.value,ejItem.value],label:`${ejItem.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                        &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field,yjItem.field],values:[dataInfo.patch.ZJ,yjItem.value,ejItem.value],label:`${ejItem.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>
                        
                        <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(2,index,yjIndex,ejIndex))">
                          <template v-for="(sjItem,sjIndex) in ejItem.nodes" :key="sjIndex"><!-- 第三层循环的值，如是否种植下的耕种条件下的种植类别 -->
                            <template v-if="sjItem.count > 0">
                              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ sjItem.name }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:dataInfo.TCMC,condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.${item.field}=='${yjItem.value}' && item.${yjItem.field}=='${ejItem.value}' && item.${ejItem.field}=='${sjItem.value}'`})">{{sjItem.count }}</a>个图斑，
                              {{ sjItem.area.toFixed(2) }}亩 
                              &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field,yjItem.field,ejItem.field],values:[dataInfo.patch.ZJ,yjItem.value,ejItem.value,sjItem.value],label:`${yjItem.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                              &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:['ZJ',item.field,yjItem.field,ejItem.field],values:[dataInfo.patch.ZJ,yjItem.value,ejItem.value,sjItem.value],label:`${yjItem.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>
                            </template>                        
                          </template>
                        </div>
                      </template>                    
                    </template>
                  </div>                  
                </template>                
              </template>
            </template>
          </p>

          <p v-if="dataInfo.patch.zgInfo">
            <span class="info-strong">{{dataInfo.patch.zgInfo.label}}&nbsp;&nbsp;({{ dataInfo.patch.zgInfo.count }}个，{{ dataInfo.patch.zgInfo.area.toFixed(2) }}亩)</span>
            &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zgInfo,chartIndex:2,label:dataInfo.patch.zgInfo.label})"></i></span>
            <template v-for="(item,index) in dataInfo.patch.zgInfo.nodes" :key="index">
              <template v-if="item.count > 0">
                <br>&nbsp;&nbsp;&nbsp;&nbsp;<span>●{{item.label}}:&nbsp;&nbsp;<a class="info-clickable" @click="$emit('selectPatchesByConditionWithAnd',item.params.zj_params)">{{ item.count }}</a>个，{{ item.area.toFixed(2) }}亩</span>
                
              </template>
            </template>
          </p>

          <!-- <p><span class="info-strong">问题分类:</span> 共有<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.CZWT!=''`})">{{ dataInfo.patch.wtsx.wtfl.count }}</a>个问题图斑，
            {{ dataInfo.patch.wtsx.wtfl.area.toFixed(2) }}亩  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.wtsx.wtfl.value,chartIndex:2,label:dataInfo.patch.wtsx.wtfl.name})"></i></span>
            <template v-for="item in dataInfo.patch.wtsx.wtfl.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.CZWT=='${item.value}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，{{ item.area.toFixed(2).padEnd(8) }}亩 
            </template>  
          </p>
          <p><span class="info-strong">处置措施:</span> 共有<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.CZCS!=''`})">{{ dataInfo.patch.wtsx.czcs.count }}</a>个问题图斑，
            {{ dataInfo.patch.wtsx.czcs.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.wtsx.czcs.value,chartIndex:2,label:dataInfo.patch.wtsx.czcs.name})"></i></span>
            <template v-for="item in dataInfo.patch.wtsx.czcs.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('selectPatchesByCondition',{TCMC:'zzpc',condition:`item.ZJ == '${dataInfo.patch.ZJ}' && item.CZCS=='${item.value}'`})">{{String(item.count).padEnd(5) }}</a>个图斑，{{ item.area.toFixed(2).padEnd(8) }}亩 
            </template>  
          </p>           -->
        </div>
      </div>
    </div>
    <div v-else-if="dataInfo && dataInfo.patch && dataInfo.level === 1" class="menu-content">
        <!-- 昌平区信息 -->
      <div>
        <h3 class="info-title" @click="toggleSection('basicInfo')">
          基本信息
          <span>{{ sectionVisibility.basicInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.basicInfo">
          <p><span class="info-strong">区域名称:</span> {{ dataInfo.patch.QX }} </p>
          <p><span class="info-strong">区域概况:</span> 共有<a class="info-clickable" @click="$emit('selectPatchesGroupByZJ',{TCMC:dataInfo.TCMC})">{{ dataInfo.patch.jbsx.count }}</a>个图斑，
            共计{{ dataInfo.patch.jbsx.area.toFixed(2) }}亩&nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[],values:[],chartIndex:0,label:'图斑分布'})"></i></span></p>
        
          <p v-for="(item,index) in dataInfo.patch.jbsx.nodes" :key="index">
            <template v-if="item.count > 0">
              <span class="info-strong">{{item.label}}&nbsp;&nbsp;({{ item.count }}个，{{ item.area.toFixed(2) }}亩)</span>     <!-- 第一层循环，如是否种植 -->
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item,chartIndex:0,label:item.label})"></i></span>
              <template v-for="(yjItem,yjIndex) in item.nodes" :key="yjIndex"><!-- 第一层循环的值，如是否种植 -->
                <template v-if="yjItem.count>0">
                  <br>&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(0,index,yjIndex))" class="info-clickable">{{ yjItem.nodes? (isNodeSectionOpen(indexToSection(0,index,yjIndex))?'▼' : '▶') : '' }}</span>{{ yjItem.label }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],tj:{name:item.field,label:item.label,value:yjItem.value}})">{{yjItem.count }}</a>个图斑，
                  {{ yjItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],chartIndex:0,label:yjItem.label})"></i></span>
                  &nbsp;&nbsp;<span v-if="yjItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:yjItem,chartIndex:0,label:yjItem.label})"></i></span>
                  
                  <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(0,index,yjIndex))">
                    <template v-for="(ejItem,ejIndex) in yjItem.nodes" :key="ejIndex"><!-- 第二层循环的值，如是否种植下的种植条件 -->
                      <template v-if="ejItem.count > 0">
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(0,index,yjIndex,ejIndex))" class="info-clickable">{{ ejItem.nodes? (isNodeSectionOpen(indexToSection(0,index,yjIndex,ejIndex))?'▼' : '▶') : '●' }}</span> {{ejItem.label}}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],tj:{name:yjItem.field,label:yjItem.label,value:ejItem.value}})">{{ejItem.count }}</a>个图斑，
                        {{ ejItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],chartIndex:0,label:ejItem.label})"></i></span>
                        &nbsp;&nbsp;<span v-if="ejItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:ejItem,chartIndex:0,label:ejItem.label})"></i></span>

                        <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(0,index,yjIndex,ejIndex))">
                          <template v-for="(sjItem,sjIndex) in ejItem.nodes" :key="sjIndex"><!-- 第三层循环的值，如是否种植下的耕种条件下的种植类别 -->
                            <template v-if="sjItem.count > 0">
                              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ sjItem.name }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],tj:{name:ejItem.field,label:ejItem.label,value:sjItem.value}})">{{sjItem.count }}</a>个图斑，
                              {{ sjItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],chartIndex:0,label:sjItem.label})"></i></span>
                            </template>                        
                          </template>
                        </div>
                      </template>                    
                    </template>
                  </div>                  
                </template>                
              </template>
            </template>
          </p>
          
          <!-- <p><span class="info-strong">耕地类型:</span>  &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.jbsx.LX.value,chartIndex:0,label:dataInfo.patch.jbsx.LX.name})"></i></span>
            <template v-for="item in dataInfo.patch.jbsx.LX.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6)}}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['LX'],values:[item.value],tj:{name:'LX',label:dataInfo.patch.jbsx.LX.name,value:item.value}})">{{String(item.count).padEnd(5) }}</a>个图斑，
              {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['LX'],values:[item.value],chartIndex:0,label:item.name})"></i></span>
            </template>
          </p>
          <p><span class="info-strong">空间位置:</span> &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.jbsx.KJWZ.value,chartIndex:0,label:dataInfo.patch.jbsx.KJWZ.name})"></i></span>
            <template v-for="item in dataInfo.patch.jbsx.KJWZ.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable"  @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['KJWZ'],values:[item.value],tj:{name:'KJWZ',label:dataInfo.patch.jbsx.KJWZ.name,value:item.value}})">{{String(item.count).padEnd(5) }}</a>个图斑，
              {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['KJWZ'],values:[item.value],chartIndex:0,label:item.name})"></i></span>
            </template>
          </p>                     -->
        </div>
        <!-- 可以根据实际情况添加更多基本信息 -->
      </div>
      <!-- 巡查信息 -->
      <div>
        <h3 class="info-title" @click="toggleSection('inspectionInfo')">
          种植信息
          <span>{{ sectionVisibility.inspectionInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.inspectionInfo">
          
          <p v-for="(item,index) in dataInfo.patch.zzsx.nodes" :key="index">
            <template v-if="item.count > 0">
              <span class="info-strong">{{item.label}}&nbsp;&nbsp;({{ item.count }}个，{{ item.area.toFixed(2) }}亩)</span>     <!-- 第一层循环，如是否种植 -->
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item,chartIndex:1,label:item.label})"></i></span>
              <template v-for="(yjItem,yjIndex) in item.nodes" :key="yjIndex"><!-- 第一层循环的值，如是否种植 -->
                <template v-if="yjItem.count>0">
                  <br>&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(1,index,yjIndex))" class="info-clickable">{{ yjItem.nodes? (isNodeSectionOpen(indexToSection(1,index,yjIndex))?'▼' : '▶') : '' }}</span>{{ yjItem.label }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],tj:{name:item.field,label:item.label,value:yjItem.value}})">{{yjItem.count }}</a>个图斑，
                  {{ yjItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],chartIndex:1,label:yjItem.label})"></i></span>
                  &nbsp;&nbsp;<span v-if="yjItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:yjItem,chartIndex:1,label:yjItem.label})"></i></span>
                  
                  <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(1,index,yjIndex))">
                    <template v-for="(ejItem,ejIndex) in yjItem.nodes" :key="ejIndex"><!-- 第二层循环的值，如是否种植下的种植条件 -->
                      <template v-if="ejItem.count > 0">
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(1,index,yjIndex,ejIndex))" class="info-clickable">{{ ejItem.nodes? (isNodeSectionOpen(indexToSection(1,index,yjIndex,ejIndex))?'▼' : '▶') : '●' }}</span> {{ejItem.label}}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],tj:{name:yjItem.field,label:yjItem.label,value:ejItem.value}})">{{ejItem.count }}</a>个图斑，
                        {{ ejItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],chartIndex:1,label:ejItem.label})"></i></span>
                        &nbsp;&nbsp;<span v-if="ejItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:ejItem,chartIndex:1,label:ejItem.label})"></i></span>

                        <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(1,index,yjIndex,ejIndex))">
                          <template v-for="(sjItem,sjIndex) in ejItem.nodes" :key="sjIndex"><!-- 第三层循环的值，如是否种植下的耕种条件下的种植类别 -->
                            <template v-if="sjItem.count > 0">
                              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ sjItem.name }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],tj:{name:ejItem.field,label:ejItem.label,value:sjItem.value}})">{{sjItem.count }}</a>个图斑，
                              {{ sjItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],chartIndex:1,label:sjItem.label})"></i></span>
                            </template>                        
                          </template>
                        </div>
                      </template>                    
                    </template>
                  </div>                  
                </template>                
              </template>
            </template>
          </p>
          <!-- <p><span class="info-strong">是否种植:</span> &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.SFZZ.value,chartIndex:1,label:dataInfo.patch.zzsx.SFZZ.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.SFZZ.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['SFZZ'],values:[item.value],tj:{name:'SFZZ',label:dataInfo.patch.zzsx.SFZZ.name,value:item.value}})">{{String(item.count).padEnd(5) }}</a>个图斑，
              {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['SFZZ'],values:[item.value],chartIndex:1,label:item.name})"></i></span>
            </template>
          </p>   
          <p><span class="info-strong">种植条件:</span> &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.ZZTJ.value,chartIndex:1,label:dataInfo.patch.zzsx.ZZTJ.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.ZZTJ.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['ZZTJ'],values:[item.value],tj:{name:'ZZTJ',label:dataInfo.patch.zzsx.ZZTJ.name,value:item.value}})">{{String(item.count).padEnd(5) }}</a>个图斑，
              {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['ZZTJ'],values:[item.value],chartIndex:1,label:item.name})"></i></span>
            </template>
          </p>  
          <p><span class="info-strong">种植情况:</span> &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.ZZQK.value,chartIndex:1,label:dataInfo.patch.zzsx.ZZQK.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.ZZQK.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['ZZQK'],values:[item.value],tj:{name:'ZZQK',label:dataInfo.patch.zzsx.ZZQK.name,value:item.value}})">{{String(item.count).padEnd(5) }}</a>个图斑，
              {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['ZZQK'],values:[item.value],chartIndex:1,label:item.name})"></i></span>
            </template>
          </p>   
          <p><span class="info-strong">种植类别:</span> &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zzsx.ZZLB.value,chartIndex:1,label:dataInfo.patch.zzsx.ZZLB.name})"></i></span>
            <template v-for="item in dataInfo.patch.zzsx.ZZLB.value" :key="item.name">
              <template v-if="item.count > 0">
                <br> &nbsp;&nbsp;<span @click="toggleZZLBSection(item.name)" class="info-clickable">{{ isZZLBSectionOpen(item.name) ? '▼' : '▶' }}</span>  {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['ZZLB1'],values:[item.name],tj:{name:'ZZLB1',label:dataInfo.patch.zzsx.ZZLB.name,value:item.name}})">{{String(item.count).padEnd(5) }}</a>个图斑，
                {{ item.area.toFixed(2).padEnd(8) }}亩&nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['ZZLB1'],values:[item.name],chartIndex:1,label:item.name})"></i></span>
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item.value,chartIndex:1,label:item.name})"></i></span>
                <div class="subItem-p" v-show="isZZLBSectionOpen(item.name)">                  
                  <template v-for="subItem in item.value" :key="subItem.name">
                    <template  v-if="subItem.count>0">●{{ subItem.name }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['ZZZW1'],values:[subItem.value],tj:{name:'ZZZW1',label:item.name,value:subItem.value}})">{{ subItem.count }}</a>个图斑，
                      {{ subItem.area.toFixed(2) }}亩&nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['ZZZW1'],values:[subItem.value],chartIndex:1,label:subItem.name})"></i></span><br>
                    </template>
                  </template>
                </div>
              </template>              
            </template>
          </p> -->
          <!-- 可以根据实际情况添加更多巡查信息 -->
        </div>
      </div>
      <!-- 巡查信息 -->
      <div>
        <h3 class="info-title" @click="toggleSection('rectificationInfo')">
          问题信息
          <span>{{ sectionVisibility.rectificationInfo ? '[-]' : '[+]' }}</span>
        </h3>
        <div class="info-content" v-show="sectionVisibility.rectificationInfo">

          <p v-for="(item,index) in dataInfo.patch.wtsx.nodes" :key="index">
            <template v-if="item.count > 0">
              <span class="info-strong">{{item.label}}&nbsp;&nbsp;({{ item.count }}个，{{ item.area.toFixed(2) }}亩)</span>     <!-- 第一层循环，如是否种植 -->
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:item,chartIndex:2,label:item.label})"></i></span>
                &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:[item.field],values:['notnull'],label:`${item.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:[item.field],values:['notnull'],label:`${item.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>

              <template v-for="(yjItem,yjIndex) in item.nodes" :key="yjIndex"><!-- 第一层循环的值，如是否种植 -->
                <template v-if="yjItem.count>0">
                  <br>&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(2,index,yjIndex))" class="info-clickable">{{ yjItem.nodes? (isNodeSectionOpen(indexToSection(2,index,yjIndex))?'▼' : '▶') : '' }}</span>{{ yjItem.label }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],tj:{name:item.field,label:item.label,value:yjItem.value}})">{{yjItem.count }}</a>个图斑，
                  {{ yjItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],chartIndex:2,label:yjItem.label})"></i></span>
                  &nbsp;&nbsp;<span v-if="yjItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:yjItem,chartIndex:2,label:yjItem.label})"></i></span>
                  &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],label:`${yjItem.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                  &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:[item.field],values:[yjItem.value],label:`${yjItem.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>


                  <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(2,index,yjIndex))">
                    <template v-for="(ejItem,ejIndex) in yjItem.nodes" :key="ejIndex"><!-- 第二层循环的值，如是否种植下的种植条件 -->
                      <template v-if="ejItem.count > 0">
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleNodeSection(indexToSection(2,index,yjIndex,ejIndex))" class="info-clickable">{{ ejItem.nodes? (isNodeSectionOpen(indexToSection(2,index,yjIndex,ejIndex))?'▼' : '▶') : '●' }}</span> {{ejItem.label}}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],tj:{name:yjItem.field,label:yjItem.label,value:ejItem.value}})">{{ejItem.count }}</a>个图斑，
                        {{ ejItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],chartIndex:2,label:ejItem.label})"></i></span>
                        &nbsp;&nbsp;<span v-if="ejItem.nodes" class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:ejItem,chartIndex:2,label:ejItem.label})"></i></span>
                        &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],label:`${ejItem.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                        &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field],values:[yjItem.value,ejItem.value],label:`${ejItem.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>

                        <div class="subItem-p" v-show="isNodeSectionOpen(indexToSection(2,index,yjIndex,ejIndex))">
                          <template v-for="(sjItem,sjIndex) in ejItem.nodes" :key="sjIndex"><!-- 第三层循环的值，如是否种植下的耕种条件下的种植类别 -->
                            <template v-if="sjItem.count > 0">
                              <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ sjItem.name }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],tj:{name:ejItem.field,label:ejItem.label,value:sjItem.value}})">{{sjItem.count }}</a>个图斑，
                              {{ sjItem.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],chartIndex:2,label:sjItem.label})"></i></span>
                              &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getSHZTStatistics',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],label:`${sjItem.label}(反馈状态)`})"><i class="fas fa-file-signature">提交统计</i></span>
                              &nbsp;&nbsp;<span class="info-clickable" @click="$emit('getZGJGStatistics',{TCMC:dataInfo.TCMC,props:[item.field,yjItem.field,ejItem.field],values:[yjItem.value,ejItem.value,sjItem.value],label:`${sjItem.label}(整改结果)`})"><i class="fas fa-hammer">结果统计</i></span>
                            </template>                        
                          </template>
                        </div>
                      </template>                    
                    </template>
                  </div>                  
                </template>                
              </template>
            </template>
          </p>

          <p v-if="dataInfo.patch.zgInfo">
            <span class="info-strong">{{dataInfo.patch.zgInfo.label}}&nbsp;&nbsp;({{ dataInfo.patch.zgInfo.count }}个，{{ dataInfo.patch.zgInfo.area.toFixed(2) }}亩)</span>
            &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.zgInfo,chartIndex:2,label:dataInfo.patch.zgInfo.label})"></i></span>
            <template v-for="(item,index) in dataInfo.patch.zgInfo.nodes" :key="index">
              <template v-if="item.count > 0">
                <br>&nbsp;&nbsp;&nbsp;&nbsp;<span>●{{item.label}}:&nbsp;&nbsp;<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',item.params.zj_params)">{{ item.count }}</a>个，{{ item.area.toFixed(2) }}亩</span>
                &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',item.params.bar_params)"></i></span>
              </template>
            </template>
          </p>
          <!-- <p><span class="info-strong">问题分类:</span> 共有<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['CZWT'],values:['notnull'],tj:{name:'CZWT',label:dataInfo.patch.wtsx.wtfl.name,value:dataInfo.patch.wtsx.wtfl.name}})">{{ dataInfo.patch.wtsx.wtfl.count }}</a>个问题图斑，
            {{ dataInfo.patch.wtsx.wtfl.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['CZWT'],values:['notnull'],chartIndex:2,label:dataInfo.patch.wtsx.wtfl.name})"></i></span>
            &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.wtsx.wtfl.value,chartIndex:2,label:dataInfo.patch.wtsx.wtfl.name})"></i></span>
            <template v-for="item in dataInfo.patch.wtsx.wtfl.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['CZWT'],values:[item.name],tj:{name:'CZWT',label:dataInfo.patch.wtsx.wtfl.name,value:item.value}})">{{String(item.count).padEnd(5) }}</a>个图斑，
              {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['CZWT'],values:[item.value],chartIndex:2,label:item.name})"></i></span>
            </template>  
          </p>
          <p><span class="info-strong">处置措施:</span> 共有<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['CZCS'],values:['notnull'],tj:{name:'CZCS',label:dataInfo.patch.wtsx.czcs.name,value:dataInfo.patch.wtsx.czcs.name}})">{{ dataInfo.patch.wtsx.czcs.count }}</a>个问题图斑，
            {{ dataInfo.patch.wtsx.czcs.area.toFixed(2) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['CZCS'],values:['notnull'],chartIndex:2,label:dataInfo.patch.wtsx.czcs.name})"></i></span>
            &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-pie-chart" @click="$emit('getChartInfoOfPieByConfig',{cfg:dataInfo.patch.wtsx.czcs.value,chartIndex:2,label:dataInfo.patch.wtsx.czcs.name})"></i></span>
            <template v-for="item in dataInfo.patch.wtsx.czcs.value" :key="item.name">
              <br> &nbsp;&nbsp; {{ item.name.padEnd(6) }}:<a class="info-clickable" @click="$emit('setlectPatchesByConditionGroupBy',{TCMC:'zzpc',props:['CZCS'],values:[item.name],tj:{name:'CZCS',label:dataInfo.patch.wtsx.czcs.name,value:item.value}})">{{String(item.count).padEnd(5) }}</a>个图斑，
              {{ item.area.toFixed(2).padEnd(8) }}亩 &nbsp;&nbsp;<span class="info-clickable"><i class="fas fa-line-chart" @click="$emit('getChartInfoByConditionGroupBy',{TCMC:'zzpc',props:['CZCS'],values:[item.value],chartIndex:2,label:item.name})"></i></span>
            </template>  
          </p>       -->
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import FnczSetDialog from './FnczSetDialog.vue';
import SfjcSetDialog from './SfjcSetDialog.vue';
import JjlbSetDialog from './JjlbSetDialog.vue';
export default {
  name: 'InfobarMenu',
  components:{ FnczSetDialog, SfjcSetDialog, JjlbSetDialog },
  props:{
    dataInfo:{
        type:Object,
        default:null,
    },
    hidden:{
        type:Boolean,
        default:false,
    },
    roleType:{ //用户角色类型，执法队为ZFD
        type:String,
        default:'',
    },
    fnczConfig:{ //非农化处置配置（来自tableConfig/wthz.json）
        type:Object,
        default:null,
    },
    jjlbConfig:{ //紧急类别配置（来自tableConfig/wthz.json的wthz_jjlb）
        type:Object,
        default:null,
    }
  },
  computed:{
    fnczFields(){ //非农化处置相关字段，标签取自配置
      let cfg = this.fnczConfig;
      return [
        { name:'FNCZYJFL', label:(cfg && cfg.yjflLabel) || '非农处置一级分类' },
        { name:'FNCZBCYJ', label:(cfg && cfg.bcyjLabel) || '非农处置补充意见' },
      ];
    },
    isUrgentPatch(){ //是否紧急图斑：Flag不为空
      let patch = this.dataInfo ? this.dataInfo.patch : null;
      if(!patch){
        return false;
      }
      return !!(patch.Flag && String(patch.Flag).trim() !== '');
    },
    canSetJjlb(){ //可设定紧急类别的角色：保护科(GBK)且必须是管理员
      let role = localStorage.getItem('role');
      return this.roleType == 'GBK' && (role == 'admin' || role == 'superadmin');
    },
    jjlbText(){ //把JJLB位掩码按配置翻译成中文
      let cfg = this.jjlbConfig;
      let patch = this.dataInfo ? this.dataInfo.patch : null;
      if(!cfg || !cfg.items || !patch){
        return '';
      }
      let n = Number(patch.JJLB) || 0;
      return cfg.items.filter(item=>((n & Number(item.value)) === Number(item.value))).map(item=>item.label).join('、');
    },
    tableColumns(){ //当前图斑图层配置里的列
      let tableConfig = this.dataInfo ? this.dataInfo.tableConfig : null;
      return (tableConfig && tableConfig.columns) ? tableConfig.columns : [];
    },
    ybFields(){ //基本信息字段
      return this.tableColumns.filter(column=>column.cate == 'yb');
    },
    zzFields(){ //种植情况字段
      return this.tableColumns.filter(column=>column.cate == 'zz');
    },
    wtFields(){ //问题信息字段
      return this.tableColumns.filter(column=>column.cate == 'wt');
    },
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      sectionVisibility: {
        basicInfo: true,
        inspectionInfo: true,
        rectificationInfo: true
      },
      nodeSections:{},      
      isFnczDialogVisible:false, //非农化处置设定对话框是否显示
      isSfjcDialogVisible:false, //是否拒测设定对话框是否显示
      isJjlbDialogVisible:false, //紧急图斑/紧急类别设定对话框是否显示

    };
  },
  watch:{
    dataInfo:{
      handler(newValue){
        if(!newValue){
          return;
        }         
        this.nodeSections = {};
        //console.log(newZZLXSections,this.zzlbSections);
      },
      deep:false,
    }
  },  
  methods: {
    updateComponent(){  //更新组件
        this.$forceUpdate();
        
    },
    isFnczField(name){ //非农化处置相关字段（含已停用的 FNCZEJFL 二级分类），在问题信息里单独渲染，不在列表中重复显示
      return typeof name == 'string' && name.indexOf('FNCZ') == 0;
    },
    openFnczDialog(){ //打开非农化处置设定对话框
      this.isFnczDialogVisible = true;
    },
    openSfjcDialog(){ //打开是否拒测设定对话框
      this.isSfjcDialogVisible = true;
    },
    onSfjcConfirm(form){ //确定是否拒测设定，交由父组件保存
      this.isSfjcDialogVisible = false;
      let patch = this.dataInfo ? this.dataInfo.patch : null;
      this.$emit('saveSfjcSet',{
        TCMC: patch ? patch.TCMC : '',
        WYBH: patch ? patch.WYBH : '',
        SFJC: form.SFJC,
      });
    },
    openJjlbDialog(){ //打开紧急图斑/紧急类别设定对话框
      this.isJjlbDialogVisible = true;
    },
    onJjlbConfirm(form){ //确定后交由父组件保存（同时设定Flag与JJLB）
      this.isJjlbDialogVisible = false;
      let patch = this.dataInfo ? this.dataInfo.patch : null;
      if(!patch){
        return;
      }
      this.$emit('saveJjlbSet',{
        TCMC: patch.TCMC,
        WYBH: patch.WYBH,
        JJLB: form.JJLB,
      });
    },
    onJjlbChange(values){ //多选下拉设定紧急类别，选中即保存（位值求和）
      let patch = this.dataInfo ? this.dataInfo.patch : null;
      if(!patch){
        return;
      }
      let jjlb = (values || []).reduce((acc,val)=> acc | Number(val), 0);
      this.$emit('saveJjlbSet',{
        TCMC: patch.TCMC,
        WYBH: patch.WYBH,
        JJLB: jjlb,
      });
    },
    onFnczConfirm(form){ //确定非农化处置设定，交由父组件保存
      this.isFnczDialogVisible = false;
      let patch = this.dataInfo ? this.dataInfo.patch : null;
      this.$emit('saveFnczSet',{
        TCMC: patch ? patch.TCMC : '',
        WYBH: patch ? patch.WYBH : '',
        FNCZYJFL: form.FNCZYJFL,
        FNCZBCYJ: form.FNCZBCYJ,
      });
    },
    startDrag(event) {
      event.stopPropagation(); // 阻止事件冒泡
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.offsetX = this.$el.offsetLeft;
      this.offsetY = this.$el.offsetTop;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(event) {
      event.stopPropagation(); // 阻止事件冒泡
      if (this.isDragging) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        this.$el.style.left = `${this.offsetX + dx}px`;
        this.$el.style.top = `${this.offsetY + dy}px`;
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    closeMenu() {
      this.$emit("closeInfobarMenu");
    },
    toggleSection(section) {
      this.sectionVisibility[section] = !this.sectionVisibility[section];
    },
    
    indexToSection(index,yjIndex,ejIndex,sjIndex){
      let section = '';
      if(index != null){
        section += String(index).padStart(2,'0');
      }
      if(yjIndex != null){
        section += String(yjIndex).padStart(2,'0');
      }
      if(ejIndex != null){
        section += String(ejIndex).padStart(2,'0');
      }
      if(sjIndex != null){
        section += String(sjIndex).padStart(2,'0');
      }      
      return section;
    },

    shztToString(shzt){
      switch(shzt){
        case '审核中':
          return '待反馈';
        case '已通过':
          return '已反馈';
        case '未通过':
          return '需整改';
        default:
          return shzt;
      } 
    },

    toggleNodeSection(section) {      
      if(this.nodeSections[section]){
        this.nodeSections[section] = !this.nodeSections[section];  
      }else{
        this.nodeSections[section] = true;  
      }
      
    },
    isNodeSectionOpen(section) {
      return this.nodeSections[section];
    },
  }
};
</script>

<style scoped>
.infobar-menu {
  position: fixed;
  top: 15vh;
  right: 20px;
  width: 400px; /* 可以根据需要调整宽度 */
  height: 80vh;
  background-color: #f0f0f0; /* 可以根据需要调整背景颜色 */
  padding: 10px;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  z-index: 1000;
  text-align: left;
}

.menu-content{
  height: 95%;
  overflow:scroll;
  scrollbar-width: none;
}

.title-bar {
  background-color: #e0e0e0; /* 标题栏背景颜色 */
  padding: 5px;
  margin: -10px -10px 10px -10px; /* 调整标题栏的边距 */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}

.info-title {
  background-color: #d0d0d0; /* 标题背景色 */
  padding: 2px;
  cursor: pointer;
}

.info-content {
  background-color: #e8e8e8; /* 内容背景色 */
  padding-left: 1em; /* 内容开头空两格 */
  /* font-family: 'Consolas', Courier, monospace; /* 字体 */
}

.info-strong{
    font-weight: bold;
}
.indented-content {
  padding-left: 2em; /* 缩进 2 个空格 */
}

.info-clickable{
    cursor: pointer;
}

.info-clickable .fas.fa-line-chart {
    color: blue;
}

.info-clickable .fas.fa-pie-chart {
    color: blue;
}

.info-clickable .fas.fa-file-signature {
    color: rgb(100, 69, 237);
}

.info-clickable .fas.fa-hammer {
    color: rgb(100, 69, 237);
}

.subItem-p{
  padding-left: 1rem;
}
</style>
